import { Component, OnInit, Input } from '@angular/core';
import { ModalitesService, Modalite } from 'src/app/core/modalites.service';
import { BehaviorSubject } from 'rxjs';
import { InputComponent } from '../input/input.component';
import { LibellesService } from 'src/app/core/libelles.service';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { FiltreService } from '../../filtre.service';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-select-input',
  templateUrl: './select-input.component.html',
  styleUrls: ['../input/input.component.css']
})
export class SelectInputComponent extends InputComponent implements OnInit {
  @Input() nomNomenclature: string;
  modalites$: BehaviorSubject<Modalite[]>;
  constructor(
      protected modalitesService: ModalitesService,
      protected formulaireService: FormulaireService,
      protected libelleService: LibellesService,
      protected filtreService: FiltreService,
      public modeRenduService: ModeRenduService
    ) {
      super(formulaireService, libelleService, filtreService, modeRenduService);
  }
  ngOnInit() {
    super.ngOnInit();
    if (this.nomNomenclature) {
      // Si un nom de nomenclature est renseigné, on s’en sert pour récupérer les modalités
      this.modalites$ = this.modalitesService.getModalites(this.nomNomenclature);
    } else {
      this.modalites$ = this.modalitesService.getModalites(this.label);
    }
  }

}
